import Swiper from 'swiper';
// eslint-disable-next-line import/no-unresolved
import {Navigation} from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.brands-slider');

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [Navigation],

            navigation: {
                prevEl: slider.querySelector('.brands-slider__btn--prev'),
                nextEl: slider.querySelector('.brands-slider__btn--next'),
            },

            breakpoints: {
                0: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },

                768: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },

                1200: {
                    slidesPerView: 5,
                    spaceBetween: 20,
                },
            },

            slidesPerView: 'auto',
            spaceBetween: 20,
            centeredSlides: false,
            loop: false,
            watchOverflow: true,
        });
    });
});
